import apiClient from "../../../../utils/interceptor";
import { API_URLS } from "../../../../constants";
import {
  ApiResponse,
  CompanyMachineInstance,
  CompanyMachineInstanceParams,
  GetAllWindowsAccessPasswordData,
  GetWindowsAccessPasswordParams,
  GetWindowsAccessPasswordResponse,
  CreateWindowsAccessPasswordParams,
} from "./interface";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

export const getCompanyMachineInstancesByCompanyMachineID = async (
  companyMachineId: string
): Promise<ApiResponse<CompanyMachineInstance[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<CompanyMachineInstance[]>>(
      `${API_URLS.COMPANY.GET_COMPANY_MACHINE_INSTANCES_BY_ID}/${companyMachineId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching machine instances:", error);
    throw error;
  }
};

export const getReadyMachineInstancesByMachineID = async (
  machineId: string
): Promise<ApiResponse<string[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<string[]>>(
      `${API_URLS.COMPANY.GET_READY_INSTANCES_BY_MACHINE_ID}/${machineId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching machine instances:", error);
    throw error;
  }
};

export const addCompanyMachineInstance = async (
  params: CompanyMachineInstanceParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<null>>(
      API_URLS.COMPANY.ADD_COMPANY_MACHINE_INSTANCE,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding machine instance:", error);
    throw error;
  }
};

export const deleteCompanyMachineInstance = async (
  params: CompanyMachineInstanceParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.COMPANY.DELETE_COMPANY_MACHINE_INSTANCE,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: params,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting machine instance:", error);
    throw error;
  }
};

export const getAllWindowsAccessPasswords = async (
  params: GetWindowsAccessPasswordParams
): Promise<ApiResponse<GetAllWindowsAccessPasswordData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<
      ApiResponse<GetAllWindowsAccessPasswordData[]>
    >(API_URLS.COMPANY.GET_ALL_WINDOWS_ACCESS_PASSWORDS, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching all Windows access passwords:", error);
    throw error;
  }
};

export const getWindowsAccessPassword = async (
  params: GetWindowsAccessPasswordParams
): Promise<ApiResponse<GetWindowsAccessPasswordResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<
      ApiResponse<GetWindowsAccessPasswordResponse>
    >(API_URLS.COMPANY.GET_WINDOWS_ACCESS_PASSWORD, params, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Windows access password:", error);
    throw error;
  }
};

export const createWindowsAccessPassword = async (
  params: CreateWindowsAccessPasswordParams
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<null>>(
      API_URLS.COMPANY.CREATE_WINDOWS_ACCESS_PASSWORD,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating Windows access password:", error);
    throw error;
  }
};
